import React from 'react';

const NotFound = () => {
    return (
        <div >
            <div className='d-flex '>
                <img style={{ width: '33%' }} className='mx-auto' src="https://i.ibb.co/x7SqzMz/32167130.jpg" alt="" />
            </div>
        </div>
    );
};

export default NotFound;